import { render, staticRenderFns } from "./MedPrescribingInfo.vue?vue&type=template&id=17d80a11&scoped=true&"
import script from "./MedPrescribingInfo.vue?vue&type=script&lang=ts&"
export * from "./MedPrescribingInfo.vue?vue&type=script&lang=ts&"
import style1 from "./MedPrescribingInfo.vue?vue&type=style&index=1&id=17d80a11&lang=scss&rel=stylesheet&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d80a11",
  null
  
)

export default component.exports